import { render, staticRenderFns } from "./mail-send-list.vue?vue&type=template&id=2f095b1d"
import script from "./mail-send-list.vue?vue&type=script&lang=ts"
export * from "./mail-send-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports